import { render, staticRenderFns } from "./AttributeGroupPanel.vue?vue&type=template&id=63b87b10"
import script from "./AttributeGroupPanel.vue?vue&type=script&lang=js"
export * from "./AttributeGroupPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports